
import { useContext } from '@nuxtjs/composition-api'
import useShoppingList from '~/composable/useShoppingList'

export default {
  setup () {
    const { app } = useContext()

    const {
      shoppingList,
      shoppingListTotal,
      buyFamilySubscription,
      getFamilySubscriptionName,
      getDisplayPerMonthPrice,
      getTotalMonthlyDiscount
    } = useShoppingList(app)

    return {
      shoppingList,
      shoppingListTotal,
      buyFamilySubscription,
      getFamilySubscriptionName,
      getDisplayPerMonthPrice,
      getTotalMonthlyDiscount
    }
  }
}
